/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.


list

*/
import React, {useState, useEffect } from "react";

import { Card, CardHeader, CardBody, Row, Col, Input, FormGroup } from "reactstrap";

// add new codes
import { useHistory } from 'react-router-dom';
import dataTypes from "views/diary/dataType.js";

import "assets/css/coach.css";

// end

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function AddSon() {
  
  let session = JSON.parse(window.sessionStorage.getItem('sessions'));
  if(!session){
    window.location = '/';
  }

  const history = useHistory();

  const [players, setPlayers] = useState([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [uFlag, setUFlag] = useState(true);  
  const addFlag = window.sessionStorage.getItem('addFlag');

  const toPage = (e, pname) => {
    history.push('../parent/'+pname);
  }

  const onSetEmailValue = (e) => {
    setEmail(e.target.value);
  }

  const onSetPassValue = (e) => {
    setPassword(e.target.value);
  }

  const onSonRegister = (e) => {
    if(!isEmail(email)){
      alert('メールを再入力してください。');
      return;
    }
    axios.get(URL_API+"regSon", {
      params: {
        parent: session['id'],
        email: email,
        password:password
      }
    })
    .then(function (response) {
      if(response.data == 'ok'){
        history.push('../parent/userMg');
      }else{
        alert('情報が正確ではありません。');
      }
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    ); 
  }

  useEffect(() => {
    if(!session){
      window.location = '/';
    }
  }, []);
  // console.log(players);
  return (
    <>      
      <div className="content px-0 pb-0">
        <div className="titleDiv">
          <Card className="mb-0">
            <CardBody className="seldate p-1 d-flex" id='seldate' style={{color:'white'}}>
              <div className="d-flex col-12 px-2">
                <div className="col-2 col-lg-1 d-flex align-items-center px-0">
                  <i className="fas fa-chevron-left" style={{fontSize:'24px'}} onClick={(event) => toPage(event, 'userMg')}></i>
                </div>
                <div className="col-8 col-lg-10 text-center px-0 d-flex align-items-center justify-content-center head_title">
                    登録
                </div>
                <div className="col-2 col-lg-1">
                </div>
              </div>
            </CardBody>
            <CardBody className="px-1 coach-useradd">
              <Row className="px-2 mx-0 py-2">
                <Col className="col-4 col-lg-2 px-0 py-0 d-flex justify-content-start align-items-center">
                  <span className="p-1">メールアドレス : </span>
                </Col>
                <Col className="col-8 col-lg-10 d-flex justify-content-start align-items-center px-0">
                  <input type="email" className="w-100" value={email} id="email" name="email" onChange={(event) => onSetEmailValue(event)} style={{border:'0px', borderBottom:'1px solid #999'}} placeholder="メールアドレス"/>
                </Col>
              </Row>
              <Row className="px-2 mx-0 py-2">
                <Col className="col-4 col-lg-2 px-0 py-0 d-flex justify-content-start align-items-center">
                  <span className="p-1">パスワード : </span>
                </Col>
                <Col className="col-8 col-lg-10 d-flex justify-content-start align-items-center px-0">
                  <input type="password" className="w-100" value={password} id="password" name="password" onChange={(event) => onSetPassValue(event)} style={{border:'0px', borderBottom:'1px solid #999'}} placeholder="パスワード"/>
                </Col>
              </Row>
              <Row className="px-2 mx-0">                    
                <Col className="px-0 col-12">
                  <FormGroup className="mb-0">
                    <input type="button" name="user" value="登録" className="btn-round btn btn-primary" onClick={(e) => onSonRegister(e)}/>
                  </FormGroup>
                </Col>                                     
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default AddSon;
